

















































































import { Vue, Component } from "vue-property-decorator";
import api from "@/getinfo-api";
import CustomInput from "@/components/form/CustomInput.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { UserRegistration as IUserRegistration } from "@/api/models/user-registration";
import { User as IUser } from "@/api/models/user";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CustomInput }
})
export default class CreateNewEmployeeForm extends Vue {
  private username: string = "";
  private email: string = "";
  private plainPassword: string = "";
  private firstName: string = "";
  private lastName: string = "";
  private phone: string = "";
  private middleName: string = "";

  get selectedCompanyTitle() {
    return this.$store.getters.selectedCompany.title;
  }

  get selectedCompanyId() {
    return this.$store.getters.selectedCompany.id;
  }

  get isShowCopyPasswordIcon() {
    return (
      (this.username?.length || this.email?.length) &&
      this.plainPassword?.length
    );
  }

  copy() {
    const text = `Email: ${
      this.email ? this.email : this.$tc(this.$translate.NotSpecified)
    }\n${this.$tc(this.$translate.Login)}: ${
      this.username
        ? this.username
        : `${this.$tc(this.$translate.NotSpecified)}`
    }\n${this.$tc(this.$translate.Password)}: ${this.plainPassword}\n${this.$tc(
      this.$translate.LoginLink
    )}: ${window.location.origin}`;
    navigator.clipboard.writeText(text);
    this.$store.dispatch("successToast", {
      message: this.$tc(this.$translate.AccessCopied)
    });
  }

  registration() {
    const userInfo: IUserRegistration = {
      username: this.username,
      email: this.email,
      plainPassword: this.plainPassword,
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      middleName: this.middleName
    };
    api.UsersApi.registration(userInfo)
      .then((res: { data: IUser }) => {
        api.CompanyApi.addEmployee(this.selectedCompanyId, res.data.id)
          .then(() => {
            this.$router.push({
              name: "companyPage",
              params: { id: this.selectedCompanyId }
            });
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
  setFirstName(item: string) {
    this.firstName = item;
    this.firstName[0].toUpperCase();
  }

  setLastName(item: string) {
    this.lastName = item;
  }

  setUserName(item: string) {
    this.username = item;
  }

  setMiddleName(item: string) {
    this.middleName = item;
  }

  setPhone(item: string) {
    this.phone = item;
  }

  setEmail(item: string) {
    this.email = item;
  }

  setPlainPassword(item: string) {
    this.plainPassword = item;
  }
}
